import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

function BuySetLink(): ReactNode {
    const { t } = useTranslation(['login']);

    return (
        <a
            className='forgot-pass t-14'
            href='https://csky.space/astra_luckfox'
            target="_blank"
            rel="noopener"
        >
            {t('buy_a_set')}
        </a>
    );
}

export default BuySetLink;
